import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-428da2a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cart-container"
};
const _hoisted_2 = {
  class: "sellable-items"
};
const _hoisted_3 = {
  key: 0,
  class: "empty-cart"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "You have no items in your shopping cart.", -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  key: 0,
  class: "title exo"
};
const _hoisted_7 = {
  class: "series-name exo"
};
const _hoisted_8 = {
  class: "non-sellable-items"
};
const _hoisted_9 = {
  key: 0,
  class: "title"
};
const _hoisted_10 = {
  class: "series-name exo"
};
const _hoisted_11 = {
  key: 0,
  class: "drawer-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cart_view_item_card = _resolveComponent("cart-view-item-card");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.isEmpty ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseSeriesNames, (name, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: name,
      class: "card-items"
    }, [index === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Items for Purchase")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, _toDisplayString(name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseItems.filter(item => (item.metadata?.seriesName ?? '') === name), item => {
      return _openBlock(), _createBlock(_component_cart_view_item_card, {
        key: item.id,
        cartItem: item,
        "show-purchase-options": true
      }, null, 8, ["cartItem"]);
    }), 128))]);
  }), 128))]), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rfpSeriesNames, (name, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: name,
      class: "card-items"
    }, [index === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Request for Products")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, _toDisplayString(name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rfpProducts.filter(item => (item.metadata?.seriesName ?? '') === name), item => {
      return _openBlock(), _createBlock(_component_cart_view_item_card, {
        key: item.id,
        cartItem: item,
        "show-purchase-options": false
      }, null, 8, ["cartItem"]);
    }), 128))]);
  }), 128))]), !_ctx.isEmpty ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_button, {
    size: "large",
    type: "primary",
    onClick: _ctx.handleCheckout
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.checkoutButtonText), 1)]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true)]);
}